<ng-container *ngIf="serviceData">
    <ng-template #sheetTemp>
        <div *ngIf="serviceData?.formData" class="preview-container">
            <span>
                <div class="head-section">
                    <div class="d-flex flex-row align-items-center justify-content-between">
                        <div class="mat-body-1 text-black mb-0">{{ serviceData.formData?.title }}</div>

                        <button mat-icon-button (click)="closeForm(true)">
                            <mat-icon class="text-hint">cancel</mat-icon>
                        </button>
                    </div>

                    <div class="mat-body-2 text-hint mb-8">
                        {{ serviceData.formData?.description }}
                    </div>
                    <mat-divider></mat-divider>

                    <div class="search-focus-container" [class.search-selected]="searchPanelOpened">
                        <div class="custom-search-bar">
                            <input type="text" [placeholder]="'Search or create service type...'"
                                [(ngModel)]="searchInputValue" maxlength="50" (focus)="openSearchPanel()"
                                (ngModelChange)="getValidateServicePattern()" />

                            <mat-icon class="search-info text-hint">search</mat-icon>
                            <button *ngIf="searchPanelOpened" mat-icon-button class="search-cancel-btn"
                                (click)="resetSearch()">
                                <mat-icon class="material-icons-outlined text-hint">close</mat-icon>
                            </button>
                        </div>

                        <mat-card class="search-option-panel mat-elevation-z3" [class.opened]="searchPanelOpened"
                            [class.has-search-text]="searchInputValue.length">
                            <div class="search-panel-inner-action">
                                <button *ngIf="!reachedMaxLimit && searchInputValue.length" mat-button class="px-8"
                                    (click)="createService()"
                                    [disabled]="createRequestInProgress || !!searchInputErrors.length">
                                    <span
                                        [class.secondary-text]="!createRequestInProgress && !searchInputErrors.length">Create
                                        new service type</span>
                                    <span> "{{searchInputValue.trim()}}"</span>
                                </button>
                                <div *ngFor="let errorMsg of searchInputErrors" class="mat-body-2 warn-text px-16 pt-8">
                                    {{errorMsg}}</div>
                            </div>

                            <div class="mat-body-2 px-16 pt-16 highlighted-text mb-8">Results</div>
                            <div *ngIf="!searchServices?.length" class="mb-16">
                                <mat-divider class="mb-8"></mat-divider>
                                <div class="mat-body-2 pt-12 px-16">{{'No results found for this searched service
                                    type'}}</div>
                            </div>
                            <mat-list #autoServiceList class="p-0">
                                <ng-container
                                    *ngFor="let _service of searchServices; let i = index; let lastitem = last; trackBy: trackByFn">
                                    <mat-list-item>
                                        <div class="d-flex align-items-center">
                                            <mat-checkbox [checked]="_service.checked"
                                                (change)="listChange($event.checked, _service.id)"
                                                [disabled]="!_service.checked && reachedMaxLimit"></mat-checkbox>
                                            <span style="max-width: 580px;"
                                                class="text-truncate pl-16">{{_service.name}}</span>
                                        </div>
                                    </mat-list-item>
                                    <mat-divider *ngIf="!lastitem"></mat-divider>
                                </ng-container>
                            </mat-list>
                        </mat-card>

                        <div class="services-checked-list mt-12">
                            <div class="mat-body-2 mb-8">Selected service types (max {{maxLimit}}):</div>

                            <mat-chip-listbox class="mb-2">
                                <mat-chip-option
                                    *ngFor="let _service of checkedServices; let i = index; trackBy: trackByFn"
                                    [removable]="true" (removed)="listChange(false, _service.id)"
                                    class="trigger-chip custom-chip-style">{{ _service.name }}
                                    <mat-icon matChipRemove>cancel</mat-icon>
                                </mat-chip-option>
                            </mat-chip-listbox>

                            <div *ngIf="!checkedServices.length" class="mat-body-2 pt-12 px-16">{{'0 service types
                                selected'}}</div>
                            <div *ngIf="maxLimitErrorFlag" class="mat-body-2 warn-text pt-12">{{'Maximum limit reached.
                                You can add up to ' + maxLimit + ' service types only. Try removing one before adding a
                                new one.'}}</div>
                        </div>
                    </div>
                </div>

                <div class="content-section-padding">
                    <div class="content-margins">
                        <div class="service-check-list mt-12" *ngIf="!searchPanelOpened">
                            <div class="mat-subheading-2 m-0">Available Service Types</div>
                            <mat-divider></mat-divider>
                            <mat-list #serviceList class="p-0">
                                <ng-container
                                    *ngFor="let _service of serviceListValues; let i = index; let lastitem = last; trackBy: trackByFn">
                                    <mat-list-item>
                                        <div class="d-flex align-items-center">
                                            <mat-checkbox [checked]="_service.checked"
                                                (change)="listChange($event.checked, _service.id)"
                                                [disabled]="!_service.checked && reachedMaxLimit"></mat-checkbox>
                                            <span style="max-width: 580px;"
                                                class="text-truncate pl-16">{{_service.name}}</span>
                                        </div>
                                    </mat-list-item>
                                    <mat-divider *ngIf="!lastitem"></mat-divider>
                                </ng-container>
                            </mat-list>

                            <div *ngIf="!serviceListValues.length" class="mat-body-2 pt-12 px-16 mb-12">{{'No service
                                types available. Use the above search to create a service type by typing the name.'}}
                            </div>
                        </div>
                    </div>
                </div>
            </span>

            <div class="action-section">
                <div class="d-flex align-items-center justify-content-between h-48">
                    <button mat-button class="mx-8" (click)="clearAll()">
                        {{ serviceData?.formData?.buttons?.[0] || '' }}
                    </button>
                    <span>
                        <button mat-button class="mx-8" (click)="closeForm(true)">
                            {{ serviceData?.formData?.buttons?.[1] || '' }}
                        </button>
                        <button mat-button color="accent" (click)="closeForm()">
                            {{ serviceData?.formData?.buttons?.[2] || '' }}
                        </button>
                    </span>
                </div>
            </div>
        </div>
    </ng-template>
</ng-container>